import { createReducer } from 'utils/redux';

export const CHANGE_LOCATION = 'router/CHANGE_LOCATION';

const initialState = {
  location: {}
};

export function changeLocation(location) {
  return dispatch => {
    dispatch({
      type: CHANGE_LOCATION,
      payload: {
        location
      }
    });
    return Promise.resolve();
  };
}

export default createReducer('router', initialState, {
  [CHANGE_LOCATION]: (state, { location }) => ({
    ...state,
    location: {
      ...location
    }
  })
});
